// extracted by mini-css-extract-plugin
export var card = "members-module--card--50ab8";
export var info = "members-module--info--0b0a3";
export var name = "members-module--name--449f3";
export var photo = "members-module--photo--9b64f";
export var role = "members-module--role--f21ca";
export var socials = "members-module--socials--2d176";
export var wrapper = "members-module--wrapper--c41f7";